import React from 'react';
import { InputAdornment, InputBase } from '@mui/material';
import PropTypes from 'prop-types';

import Iconify from '../iconify';

export default function CustomInputBase({ setQuery, autoFocus }) {
  return (
    <InputBase
      autoFocus={autoFocus}
      onChange={(e) => setQuery(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ pl: 2 }}>
            {' '}
            <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
          </InputAdornment>
        ),
      }}
      sx={{ flex: 1 }}
      placeholder="ፈልግ..."
      inputProps={{ 'aria-label': 'Search...' }}
    />
  );
}

CustomInputBase.propTypes = {
  setQuery: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool.isRequired,
};
